const SERVICE = '/messages';

const MARK_MESSAGE_AS_READ = `${SERVICE}/read`;

const messages = {
    MARK_MESSAGE_AS_READ,
};

export default messages;
